import style from "./WordScroller.css";
import * as React from "react";

export function WordScroller() {
  return (
    <div className={style.container}>
      <span>Engineering</span>
      <div className={style.rotate}>
        <span>innovative</span>
        <span>safe</span>
        <span>resilient</span>
        <span>sustainable</span>
        <span>ethical</span>
        <span>innovative</span>
        <span>safe</span>
        <span>resilient</span>
        <span>sustainable</span>
        <span>ethical</span>
        <span>innovative</span>
      </div>
      <div className={style.wrap}>solutions for the digital age.</div>
    </div>
  )
}